module.exports = __webpack_public_path__ + "img/tit_tg_jj.137bb19c.png";